import api from "../services/api";

const sanitizeFileName = (value) =>
  String(value || "arquivo")
    .replace(/[\\/:*?"<>|]+/g, "_")
    .trim() || "arquivo";

const fileNameFromUrl = (url) => {
  try {
    const parsed = new URL(url, window.location.origin);
    const candidate = decodeURIComponent(parsed.pathname.split("/").pop() || "");
    return sanitizeFileName(candidate || "arquivo");
  } catch (_) {
    return "arquivo";
  }
};

const fileNameFromDisposition = (disposition) => {
  if (!disposition) return "";
  const utf = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
  if (utf?.[1]) {
    try { return sanitizeFileName(decodeURIComponent(utf[1])); } catch (_) { /* fallback abaixo */ }
  }
  const simple = /filename="?([^";]+)"?/i.exec(disposition);
  return simple?.[1] ? sanitizeFileName(simple[1]) : "";
};

export const downloadMediaFile = async (url, fallbackName) => {
  if (!url) return;

  let blob;
  let contentDisposition = "";

  if (String(url).startsWith("blob:")) {
    const response = await fetch(url);
    blob = await response.blob();
  } else {
    const response = await api.get(url, { responseType: "blob" });
    blob = new Blob([response.data], {
      type: response.headers?.["content-type"] || response.data?.type || "application/octet-stream",
    });
    contentDisposition = response.headers?.["content-disposition"] || "";
  }

  const filename = sanitizeFileName(
    fallbackName || fileNameFromDisposition(contentDisposition) || fileNameFromUrl(url)
  );

  const objectUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = filename;
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1500);
};

export const mediaFileName = fileNameFromUrl;
